export const useStyles = (theme) => ({
  button: {
    "& span": {
      textTransform: "none",
    },
  },
  menuItem: {
    color: theme.palette.text.primary,
    textDecoration: "none !important",
  },
});
